{
  "seo": {
    "title": "For Families — Why Subscribe",
    "description": "See exactly what your family gets with CuriPop: free vs paid features, outcomes, and the best plan for curious kids.",
    "keywords": "for families, why subscribe, kids app subscription, free vs paid learning app"
  },
  "hero": {
    "title": "Why Families Choose CuriPop",
    "subtitle": "Start free, then upgrade only when your child wants more depth, more personalization, and stronger progress tracking.",
    "primaryCta": "Start Free",
    "secondaryCta": "Compare Plans"
  },
  "outcomes": {
    "title": "Concrete Outcomes for Families",
    "items": [
      {
        "title": "More learning in less time",
        "detail": "Unlimited questions and deeper answers help kids stay in the learning flow without hitting stop points."
      },
      {
        "title": "Right reading level every time",
        "detail": "Personalized reading levels keep each child challenged without frustration, from early readers to confident readers."
      },
      {
        "title": "Clear parent visibility",
        "detail": "Progress snapshots and learning trends show what each child is exploring so families can guide the next step."
      },
      {
        "title": "Parent controls built in",
        "detail": "Manage profiles, privacy, and learning settings in one place with child-safe defaults from day one."
      }
    ]
  },
  "comparison": {
    "title": "Free vs Family Plan",
    "subtitle": "A quick look at what changes when you upgrade.",
    "headers": {
      "feature": "Feature",
      "free": "Free",
      "family": "Family"
    },
    "rows": [
      {
        "feature": "Daily questions",
        "free": "12/day (rotating)",
        "family": "Unlimited"
      },
      {
        "feature": "Reading level personalization",
        "free": "Basic",
        "family": "Per child profile"
      },
      {
        "feature": "Progress insights",
        "free": "Limited",
        "family": "Detailed reports"
      },
      {
        "feature": "Parent controls",
        "free": "Basic",
        "family": "Advanced controls"
      },
      {
        "feature": "Child profiles",
        "free": "1",
        "family": "Up to 5"
      },
      {
        "feature": "New content access",
        "free": "Standard",
        "family": "Priority access"
      }
    ],
    "link": "See full pricing details"
  },
  "cta": {
    "title": "Built for Real Family Routines",
    "subtitle": "Families use CuriPop during homework, bedtime questions, and weekend curiosity sessions. Start free and keep progress as your child grows.",
    "primary": "Start Free",
    "secondary": "Read Family Stories",
    "disclaimer": "7-day family trial, cancel anytime"
  }
}
